import { UserRoleDTO } from "./UserRoleDTO";

export class DeactivateUsersRequestDTO {
    userAfms:string[];
    loggedInUser:UserRoleDTO;
}